<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <g fill="none" stroke="#999" stroke-linecap="round" stroke-width="1.5">
      <path d="M8 1a7.506 7.506 0 0 1 2.319.393A6.9 6.9 0 0 1 15 8 7 7 0 0 1 1 8a7.13 7.13 0 0 1 3.495-6.061"/>
      <path d="M-2.494 9.586c.086-.845.31-3.21.31-3.21l-3.382.057" stroke-linejoin="round" stroke-width="1.50021"/>
      <path d="M8 5v4.14l2.074 1.24" stroke-linejoin="round"/>
    </g>
  </svg>
</template>
